// RPD lookup — snapshot of the /rebus builder's data/rpds.json (99 playable + 1 dropped), plus
// the 3 reserved warm-up RPDs (data/practice_rpds.json). getRPD(id) returns the descriptor the
// canvas renderer draws; dropped puzzles (19_10) are excluded. The practice RPDs render through
// the same path (RebusPicture → getRPD) but are NOT in the playable set — they live outside
// REBUS_PUZZLES (see practice.data.ts), so they can never be drawn for a scored/free-play puzzle.
import rpdsRaw from './rpds.json'
import practiceRpdsRaw from './practice_rpds.json'
import type { RPD } from './rpdRender'

const all = rpdsRaw as unknown as (RPD & { drop?: boolean })[]
const practice = practiceRpdsRaw as unknown as RPD[]

const byId = new Map<string, RPD>()
for (const r of all) if (r.id && !r.drop) byId.set(r.id, r)
for (const r of practice) if (r.id) byId.set(r.id, r)

export const getRPD = (id: string): RPD | undefined => byId.get(id)

// Ids removed from the sample (rendered nowhere, served nowhere). Used to filter the play set.
export const DROPPED_IDS: ReadonlySet<string> = new Set(all.filter((r) => r.drop && r.id).map((r) => r.id as string))
